<template>
	<div class="header">
		<!-- 折叠按钮 -->
		<div class="top_shade">
			<div class="logo">
				<div class="flex align-center justify-center">
					<img src="../../assets/img/logo@2x.png" alt="">
				</div>
				<div class="logo_text">
					网络会议
				</div>
				<!-- <div class="collapse-btn" @click="collapseChage">
				    <i v-if="!collapse" class="el-icon-s-fold"></i>
				    <i v-else class="el-icon-s-unfold"></i>
				</div> -->	
			</div>
			<div class="header-right">
				<div class="header-user-con">
					<!-- 用户头像 -->
					<div class="user-avator">
						<img src="../../assets/img/name.png" />
					</div>
					<div class="" style="margin: 0px 10px;">
						{{ userInfo.name }}
					</div>
					<div v-if="userInfo.type !='CREDITOR' && userInfo.type !='AGENT'" class="" style="font-size: 12px;padding: 2px 5px;background-color: rgba(255,255,255,0.5);color: #0052D9;border-radius: 2px;">
						{{ chuli(userInfo.type)}}
					</div>
					<div class="user-avator">
						<el-dropdown class="user-name" trigger="hover" @command="handleCommand">
							 <span class="el-dropdown-link">
							    <img slot="reference" style="width: 44px;height: 40px;" src="../../assets/img/exit.png" />
							  </span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					<!-- <el-popconfirm title="确认退出吗？" confirm-button-type="text"
						@onConfirm="handleCommand('loginout')">
						<img slot="reference" style="width: 44px;height: 40px;" src="../../assets/img/exit.png" />
					</el-popconfirm> -->
					</div>
					
					<!-- 用户名下拉菜单 -->
					<!-- <el-dropdown class="user-name" trigger="hover" @command="handleCommand">
						<span class="el-dropdown-link">
							{{ chuli(userInfo.type)}}
							<i class="el-icon-caret-bottom"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown> -->
				</div>
			</div>
		</div>
		<!-- <div class="logo">网络会议参会平台</div> -->
		
	</div>
</template>
<script>
	import bus from '@/utils/bus';
	import {
		mapState,
		mapMutations
	} from 'vuex';
	import {
		authInfo
	} from '@/serve/user';
	import {
		userInfo
	} from 'os';
	export default {
		data() {
			return {
				collapse: false,
				fullscreen: false,
				name: 'linxin',
				message: 2
			};
		},
		watch: {
			userInfo: {
				handler(newVal, oldVal) {
					if (!Object.keys(newVal).length) {
						this.$router.replace('/login');
						this.SET_SHOW();
						this.LOGOUT();
					}
				},
				immediate: true
			}
		},
		computed: {
			...mapState({
				userInfo: state => state.user.userInfo
			})
		},
		methods: {
			...mapMutations({
				LOGOUT: 'user/LOGOUT',
				SET_SHOW: 'user/SET_SHOW'
			}),
			// 用户名下拉菜单选择事件
			handleCommand(command) {
				if (command == 'loginout') {
					this.LOGOUT();
					this.$router.push('/login');
				}
			},
			// 侧边栏折叠
			collapseChage() {
				this.collapse = !this.collapse;
				bus.$emit('collapse', this.collapse);
			},
			chuli(type){
				// ADMIN 管理员/MANAGER 管理人/CREDITOR 债权人/AGENT 代理人
				console.log("type",type)
				if(type == 'ADMIN'){
					return "管理员"
				}else if(type == 'MANAGER'){
					return "管理人"
				}else if(type == 'OTHER'){
					return "其他人员"
				}
				// else if(type == 'CREDITOR'){
				// 	return "债权人"
				// }else if(type == 'AGENT'){
				// 	return "代理人"
				// }
			}
		},
		mounted() {
			if (document.body.clientWidth < 1500) {
				this.collapseChage();
			}
		}
	};
</script>
<style scoped>
	.header {
		position: relative;
		z-index: 2;
		box-sizing: border-box;
		width: 100%;
		height: 64px;
		font-size: 22px;
		color: #fff;
	}

	.top_shade {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.logo {
		display: flex;
		align-items: center;
	}
	.logo img {
		width: 120px;
		height: 36px;
		margin-left: 20px;
		margin-right: 20px;
	}

	.logo_text {
		padding-left: 20px;
		border-left: 1px solid #FFFFFF;
		font-size: 20px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 22px;
	}

	.official_website {
		display: flex;
		align-items: center;
		margin-right: 20px;
	}

	.collapse-btn {
		float: left;
		padding: 0 21px;
		cursor: pointer;
		line-height: 70px;
	}

	.header .logo {
		float: left;
		line-height: 70px;
		font-size: 29px;
		font-weight: bold;
	}

	.header-right {
		float: right;
		padding-right: 50px;
	}

	.header-user-con {
		display: flex;
		height: 70px;
		align-items: center;
		font-size: 16px;
	}

	.btn-fullscreen {
		transform: rotate(45deg);
		margin-right: 5px;
		font-size: 24px;
	}

	.btn-bell,
	.btn-fullscreen {
		position: relative;
		width: 30px;
		height: 30px;
		text-align: center;
		border-radius: 15px;
		cursor: pointer;
	}

	.btn-bell-badge {
		position: absolute;
		right: 0;
		top: -2px;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background: #f56c6c;
		color: #fff;
	}

	.btn-bell .el-icon-bell {
		color: #fff;
	}

	.user-name {
		margin-left: 10px;
	}

	.user-avator {
		margin-left: 50px;
	}

	.user-avator img {
		display: block;
		width: 30px;
		height: 30px;
	}

	.el-dropdown-link {
		color: #fff;
		cursor: pointer;
	}

	.el-dropdown-menu__item {
		text-align: center;
	}
</style>
